module.exports = __webpack_public_path__ + "media/media/values/anton-poleschuk-cc18325f5826ab0bbd3a2358b72da6cb.jpg";